export const faqCategories = [
    {
        id: 'general-faqs',
        title: 'FAQ_CATEGORY_GENERAL',
        icon: '../../../assets/images/Icons/faqicons/hand-holding-heart.svg',
        questionKeyList: ['FAQ_KEY_1', 'FAQ_KEY_2', 'FAQ_KEY_25', 'FAQ_KEY_26']
    },
    {
        id: 'login-faqs',
        title: 'FAQ_CATEGORY_LOGIN',
        icon: '../../../assets/images/Icons/faqicons/account-management.svg',
        questionKeyList: ['FAQ_KEY_36', 'FAQ_KEY_5', 'FAQ_KEY_6', 'FAQ_KEY_37', 'FAQ_KEY_17', 'FAQ_KEY_18', 'FAQ_KEY_19', 'FAQ_KEY_20', 'FAQ_KEY_21', 'FAQ_KEY_38', 'FAQ_KEY_22', 'FAQ_KEY_23', 'FAQ_KEY_24']
    },
    {
        id: 'apply-coverage-faqs',
        title: 'FAQ_CATEGORY_APPLYING',
        icon: '../../../assets/images/Icons/faqicons/apply-coverage.svg',
        questionKeyList: ['FAQ_KEY_33', 'FAQ_KEY_34', 'FAQ_KEY_3']
    },
    {
        id: 'caselink-faqs',
        title: 'FAQ_CATEGORY_LINKING',
        icon: '../../../assets/images/Icons/faqicons/link-my-case.svg',
        questionKeyList: ['FAQ_KEY_7', 'FAQ_KEY_8', 'FAQ_KEY_9', 'FAQ_KEY_10']
    },
    {
        id: 'notification-faqs',
        title: 'FAQ_CATEGORY_NOTIFICATION',
        icon: '../../../assets/images/Icons/faqicons/envelope.svg',
        questionKeyList: ['FAQ_KEY_11', 'FAQ_KEY_12', 'FAQ_KEY_13', 'FAQ_KEY_14']
    },
    {
        id: 'my-coverage-faqs',
        title: 'FAQ_CATEGORY_COVERAGE',
        icon: '../../../assets/images/Icons/faqicons/heart.svg',
        questionKeyList: ['FAQ_KEY_4', 'FAQ_KEY_35', 'FAQ_KEY_15', 'FAQ_KEY_16','FAQ_KEY_40','FAQ_KEY_41','FAQ_KEY_42','FAQ_KEY_43','FAQ_KEY_44', 'FAQ_KEY_48']
    },
    {
        id: 'appeal-faqs',
        title: 'FAQ_CATEGORY_APPEAL',
        icon: '../../../assets/images/Icons/faqicons/gavel-full.svg',
        questionKeyList: ['FAQ_KEY_27', 'FAQ_KEY_28', 'FAQ_KEY_29', 'FAQ_KEY_30', 'FAQ_KEY_31', 'FAQ_KEY_32','FAQ_KEY_47', 'FAQ_KEY_49', 'FAQ_KEY_45', 'FAQ_KEY_46']
    }
];


export const faqPartnerCategories = [
    {
        id: 'general-faqs',
        title: 'FAQ_CATEGORY_GENERAL',
        icon: '../../../assets/images/Icons/faqicons/general-qs.svg',
        questionKeyList: ['FAQ_KEY_RP_1', 'FAQ_KEY_RP_2', 'FAQ_KEY_RP_29', 'FAQ_KEY_RP_3','FAQ_KEY_RP_4','FAQ_KEY_RP_5','FAQ_KEY_RP_6','FAQ_KEY_RP_7','FAQ_KEY_RP_8','FAQ_KEY_RP_9','FAQ_KEY_RP_10','FAQ_KEY_RP_11'
        ]
    },
    {
        id: 'access-request-faqs',
        title: 'FAQ_CATEGORY_ACCESS_REQUEST',
        icon: '../../../assets/images/Icons/faqicons/org-admin.svg',
        questionKeyList: ['FAQ_KEY_RP_12','FAQ_KEY_RP_13','FAQ_KEY_RP_14','FAQ_KEY_RP_15']
    },
    {
        id: 'profile-faqs',
        title: 'FAQ_CATEGORY_PROFILE',
        icon: '../../../assets/images/Icons/faqicons/profile.svg',
        questionKeyList: ['FAQ_KEY_RP_16', 'FAQ_KEY_RP_17', 'FAQ_KEY_RP_18', 'FAQ_KEY_RP_19','FAQ_KEY_RP_20','FAQ_KEY_RP_21','FAQ_KEY_RP_22']
    },
    {
        id: 'otp-faqs',
        title: 'FAQ_CATEGORY_PASSCODE',
        icon: '../../../assets/images/Icons/faqicons/lock-full.svg',
        questionKeyList: ['FAQ_KEY_RP_23', 'FAQ_KEY_RP_24', 'FAQ_KEY_RP_25', 'FAQ_KEY_RP_26','FAQ_KEY_RP_27','FAQ_KEY_RP_28']
    },
    {
        id: 'doc-upload-faqs',
        title: 'FAQ_CATEGORY_DOCUPLOAD',
        icon: '../../../assets/images/Icons/faqicons/doc_upload.svg',
        questionKeyList: ['DOCUPLOAD_FAQ_HEADER_01', 'DOCUPLOAD_FAQ_HEADER_02', 'DOCUPLOAD_FAQ_HEADER_03', 'DOCUPLOAD_FAQ_HEADER_04']
    }
];



export const faqData = [{
    header: 'FREQUENTLY_ASKED_QUESTIONS',
    questions: [
        {
            key: 'FAQ_KEY_1',
            value: 'FAQ_VALUE_1',
            show: false
        },
        {
            key: 'FAQ_KEY_36',
            value: 'FAQ_VALUE_36',
            show: false
        },
        {
            key: 'FAQ_KEY_33',
            value: 'FAQ_VALUE_33',
            show: false
        },
        {
            key: 'FAQ_KEY_34',
            value: 'FAQ_VALUE_34',
            show: false
        },
        {
            key: 'FAQ_KEY_2',
            value: 'FAQ_VALUE_2',
            show: false
        },
        {
            key: 'FAQ_KEY_3',
            value: 'FAQ_VALUE_3',
            show: false
        },
        {
            key: 'FAQ_KEY_4',
            value: 'FAQ_VALUE_4',
            show: false
        },
        {
            key: 'FAQ_KEY_5',
            value: 'FAQ_VALUE_5',
            show: false
        },
        {
            key: 'FAQ_KEY_6',
            value: 'FAQ_VALUE_6',
            show: false
        },
        {
            key: 'FAQ_KEY_7',
            value: 'FAQ_VALUE_7',
            show: false
        },
        {
            key: 'FAQ_KEY_8',
            value: 'FAQ_VALUE_8',
            show: false
        },
        {
            key: 'FAQ_KEY_37',
            value: 'FAQ_VALUE_37',
            show: false
        },
        {
            key: 'FAQ_KEY_39',
            value: 'FAQ_VALUE_39',
            show: false
        },
        {
            key: 'FAQ_KEY_9',
            value: 'FAQ_VALUE_9',
            show: false
        },
        {
            key: 'FAQ_KEY_10',
            value: 'FAQ_VALUE_10',
            show: false
        },
        {
            key: 'FAQ_KEY_35',
            value: 'FAQ_VALUE_35',
            show: false
        },
        {
            key: 'FAQ_KEY_11',
            value: 'FAQ_VALUE_11',
            show: false
        },
        {
            key: 'FAQ_KEY_12',
            value: 'FAQ_VALUE_12',
            show: false
        },
        {
            key: 'FAQ_KEY_13',
            value: 'FAQ_VALUE_13',
            show: false
        },
        {
            key: 'FAQ_KEY_14',
            value: 'FAQ_VALUE_14',
            show: false
        },
        {
            key: 'FAQ_KEY_15',
            value: 'FAQ_VALUE_15',
            show: false
        },
        {
            key: 'FAQ_KEY_16',
            value: 'FAQ_VALUE_16',
            show: false
        },
        {
            key: 'FAQ_KEY_17',
            value: 'FAQ_VALUE_17',
            show: false
        },
        {
            key: 'FAQ_KEY_18',
            value: 'FAQ_VALUE_18',
            show: false
        },
        {
            key: 'FAQ_KEY_19',
            value: 'FAQ_VALUE_19',
            show: false
        },
        {
            key: 'FAQ_KEY_20',
            value: 'FAQ_VALUE_20',
            show: false
        },
        {
            key: 'FAQ_KEY_21',
            value: 'FAQ_VALUE_21',
            show: false
        },
        {
            key: 'FAQ_KEY_38',
            value: 'FAQ_VALUE_38',
            show: false
      },
        {
            key: 'FAQ_KEY_22',
            value: 'FAQ_VALUE_22',
            show: false
        },
        {
            key: 'FAQ_KEY_23',
            value: 'FAQ_VALUE_23',
            show: false
        },
        {
            key: 'FAQ_KEY_24',
            value: 'FAQ_VALUE_24',
            show: false
        },
        {
            key: 'FAQ_KEY_25',
            value: 'FAQ_VALUE_25',
            show: false
        },
        {
            key: 'FAQ_KEY_26',
            value: 'FAQ_VALUE_26',
            show: false
        },
        {
            key: 'FAQ_KEY_27',
            value: 'FAQ_VALUE_27',
            show: false
        },
        {
            key: 'FAQ_KEY_28',
            value: 'FAQ_VALUE_28',
            show: false
        },
        {
            key: 'FAQ_KEY_29',
            value: 'FAQ_VALUE_29',
            show: false
        },
        {
            key: 'FAQ_KEY_30',
            value: 'FAQ_VALUE_30',
            show: false
        },
        {
            key: 'FAQ_KEY_31',
            value: 'FAQ_VALUE_31',
            show: false
        },
        {
            key: 'FAQ_KEY_32',
            value: 'FAQ_VALUE_32',
            show: false
        },
        {
            key: 'FAQ_KEY_40',
            value: 'FAQ_VALUE_40',
            show: false
        },
        {
            key: 'FAQ_KEY_41',
            value: 'FAQ_VALUE_41',
            show: false
        },
        {
            key: 'FAQ_KEY_42',
            value: 'FAQ_VALUE_42',
            show: false
        },
        {
            key: 'FAQ_KEY_43',
            value: 'FAQ_VALUE_43',
            show: false
        },
        {
            key: 'FAQ_KEY_44',
            value: 'FAQ_VALUE_44',
            show: false
        },
        {
            key: 'FAQ_KEY_47',
            value: 'FAQ_VALUE_47',
            show: false
        },
        {
            key: 'FAQ_KEY_45',
            value: 'FAQ_VALUE_45',
            show: false
        },
        {
            key: 'FAQ_KEY_46',
            value: 'FAQ_VALUE_46',
            show: false
        },
        {
            key: 'FAQ_KEY_48',
            value: 'FAQ_VALUE_48',
            show: false
        },
        {
            key: 'FAQ_KEY_49',
            value: 'FAQ_VALUE_49',
            show: false
        }
    ]
}];



export const faqRPData = [{
header: 'GENERAL_QUESTIONS',
questions:[
    {
        key: 'FAQ_KEY_RP_1',
        value: 'FAQ_VALUE_RP_1',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_2',
        value: 'FAQ_VALUE_RP_2',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_29',
        value: 'FAQ_VALUE_RP_29',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_3',
        value: 'FAQ_VALUE_RP_3',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_4',
        value: 'FAQ_VALUE_RP_4',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_5',
        value: 'FAQ_VALUE_RP_5',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_6',
        value: 'FAQ_VALUE_RP_6',
        show: false
    },
    {
        key: 'DOCUPLOAD_FAQ_HEADER_01',
        value: 'DOCUPLOAD_FAQ_DESCRIPTION_01',
        show: false
    }, 
    {
        key: 'DOCUPLOAD_FAQ_HEADER_02',
        value: 'DOCUPLOAD_FAQ_DESCRIPTION_02',
        show: false
    },
    {
        key: 'DOCUPLOAD_FAQ_HEADER_03',
        value: 'DOCUPLOAD_FAQ_DESCRIPTION_03',
        show: false
    },
    {
        key: 'DOCUPLOAD_FAQ_HEADER_04',
        value: 'DOCUPLOAD_FAQ_DESCRIPTION_04',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_7',
        value: 'FAQ_VALUE_RP_7',
        show: false
    },

    {
        key: 'FAQ_KEY_RP_8',
        value: 'FAQ_VALUE_RP_8',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_9',
        value: 'FAQ_VALUE_RP_9',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_10',
        value: 'FAQ_VALUE_RP_10',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_11',
        value: 'FAQ_VALUE_RP_11',
        show: false
    },
]},
{
    header: 'ACCESS_REQUEST_QUESTIONS',
    questions:[
    {
        key: 'FAQ_KEY_RP_12',
        value: 'FAQ_VALUE_RP_12',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_13',
        value: 'FAQ_VALUE_RP_13',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_14',
        value: 'FAQ_VALUE_RP_14',
        show: false
    },
    {
        key: 'FAQ_KEY_RP_15',
        value: 'FAQ_VALUE_RP_15',
        show: false
    },
]},
{
    header: 'PROFILE_QUESTIONS',
    questions:[
        {
            key: 'FAQ_KEY_RP_16',
            value: 'FAQ_VALUE_RP_16',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_17',
            value: 'FAQ_VALUE_RP_17',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_18',
            value: 'FAQ_VALUE_RP_18',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_19',
            value: 'FAQ_VALUE_RP_19',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_20',
            value: 'FAQ_VALUE_RP_20',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_21',
            value: 'FAQ_VALUE_RP_21',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_22',
            value: 'FAQ_VALUE_RP_22',
            show: false
        },
]},
{
    header: 'ONETIME_PASSCODE_QUESTIONS',
    questions:[
        {
            key: 'FAQ_KEY_RP_23',
            value: 'FAQ_VALUE_RP_23',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_24',
            value: 'FAQ_VALUE_RP_24',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_25',
            value: 'FAQ_VALUE_RP_25',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_26',
            value: 'FAQ_VALUE_RP_26',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_27',
            value: 'FAQ_VALUE_RP_27',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_28',
            value: 'FAQ_VALUE_RP_28',
            show: false
        }
]},
];



export const faqRPNewData = [{
    header: 'FAQ_CATEGORY_GENERAL',
    questions:[
        {
            key: 'FAQ_KEY_RP_1',
            value: 'FAQ_VALUE_RP_1',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_2',
            value: 'FAQ_VALUE_RP_2',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_29',
            value: 'FAQ_VALUE_RP_29',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_3',
            value: 'FAQ_VALUE_RP_3',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_4',
            value: 'FAQ_VALUE_RP_4',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_5',
            value: 'FAQ_VALUE_RP_5',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_6',
            value: 'FAQ_VALUE_RP_6',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_7',
            value: 'FAQ_VALUE_RP_7',
            show: false
        },
    
        {
            key: 'FAQ_KEY_RP_8',
            value: 'FAQ_VALUE_RP_8',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_9',
            value: 'FAQ_VALUE_RP_9',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_10',
            value: 'FAQ_VALUE_RP_10',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_11',
            value: 'FAQ_VALUE_RP_11',
            show: false
        },
    ]},
    {
        header: 'FAQ_CATEGORY_ACCESS_REQUEST',
        questions:[
        {
            key: 'FAQ_KEY_RP_12',
            value: 'FAQ_VALUE_RP_12',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_13',
            value: 'FAQ_VALUE_RP_13',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_14',
            value: 'FAQ_VALUE_RP_14',
            show: false
        },
        {
            key: 'FAQ_KEY_RP_15',
            value: 'FAQ_VALUE_RP_15',
            show: false
        },
    ]},
    {
        header: 'FAQ_CATEGORY_PROFILE',
        questions:[
            {
                key: 'FAQ_KEY_RP_16',
                value: 'FAQ_VALUE_RP_16',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_17',
                value: 'FAQ_VALUE_RP_17',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_18',
                value: 'FAQ_VALUE_RP_18',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_19',
                value: 'FAQ_VALUE_RP_19',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_20',
                value: 'FAQ_VALUE_RP_20',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_21',
                value: 'FAQ_VALUE_RP_21',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_22',
                value: 'FAQ_VALUE_RP_22',
                show: false
            },
    ]},
    {
        header: 'FAQ_CATEGORY_PASSCODE',
        questions:[
            {
                key: 'FAQ_KEY_RP_23',
                value: 'FAQ_VALUE_RP_23',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_24',
                value: 'FAQ_VALUE_RP_24',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_25',
                value: 'FAQ_VALUE_RP_25',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_26',
                value: 'FAQ_VALUE_RP_26',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_27',
                value: 'FAQ_VALUE_RP_27',
                show: false
            },
            {
                key: 'FAQ_KEY_RP_28',
                value: 'FAQ_VALUE_RP_28',
                show: false
            }
    ]},
    {
        header: 'FAQ_CATEGORY_DOCUPLOAD',
        questions:[
            {
                key: 'DOCUPLOAD_FAQ_HEADER_01',
                value: 'DOCUPLOAD_FAQ_DESCRIPTION_01',
                show: false
            },
            {
                key: 'DOCUPLOAD_FAQ_HEADER_02',
                value: 'DOCUPLOAD_FAQ_DESCRIPTION_02',
                show: false
            },
            {
                key: 'DOCUPLOAD_FAQ_HEADER_03',
                value: 'DOCUPLOAD_FAQ_DESCRIPTION_03',
                show: false
            },
            {
                key: 'DOCUPLOAD_FAQ_HEADER_04',
                value: 'DOCUPLOAD_FAQ_DESCRIPTION_04',
                show: false
            }
    ]}
];